import settings from '../../assets/settings.json';
import Cookies from 'js-cookie'

class FunctionFields {
  postNewTonyaData(input_obj, auth_obj){
    if(input_obj['add_tonya_name_f']){
      fetch(settings.API_BASE_URL+'add_tonya/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"data":input_obj})
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data.data);
        let res = data.data.data;
        if(res===''){
          alert(res+' 追加完了!');
        }else if(res==='既にある'){
          console.dir(input_obj);
          alert(res+'\n'+input_obj['add_tonya_name_f']+' 登録ずみでした');
        }
      })
      .catch(error => {
        console.error(error)
        alert(error);
      });
    }
  }



  postUpdataTonyaData(input_obj, auth_obj){
    if(input_obj['add_tonya_name_f']){
      fetch(settings.API_BASE_URL+'update_tonya/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name , {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"data":input_obj})
      })
      .then(response => response.json())
      .then(data => {
        console.dir(data.data);
        let res = data.data.data;
        if(res===''){
          alert(res+' 編集完了!');
        }else if(res==='該当なし'){
          console.dir(input_obj);
          alert(res+'\n'+input_obj['add_tonya_name_f']+' 変更されていません.');
        }
      })
      .catch(error => {
        console.error(error)
        alert(error);
      });
    }
  }



  changeSettingsData(input_obj, auth_obj){
    console.dir(input_obj);

    fetch(settings.API_BASE_URL+'update_settings/' + '?token=' + auth_obj.token + '&name='+ auth_obj.name , {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({"data":input_obj})
    })
    .then(response => response.json())
    .then(data => {
      console.dir(data.data);
      let res = data.data.data;
      if(res===''){
        alert(res+' 変更完了!');
      }else if(res==='該当なし'){
        //console.dir(input_obj);
        //alert(res+'\n'+input_obj['add_tonya_name_f']+' 変更されていません.');
      }
    })
    .catch(error => {
      console.error(error)
      alert(error);
    });
    
  }




  getTonyaList(staff_token, staff_name){
    const url = settings.API_BASE_URL + 'teigi_get/' + '?token=' + staff_token + '&name='+ staff_name ;
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj);
    return response_obj.data;

  }


  getSettingsList(staff_token, staff_name){
    const url = settings.API_BASE_URL + 'get_settings_info/' + '?token=' + staff_token + '&name='+ staff_name ;
    console.log(url);
    var Httpreq = new XMLHttpRequest();
    Httpreq.open("GET", url, false);
    Httpreq.send(null);
    var response_obj = JSON.parse(Httpreq.responseText)['data'];
    console.dir(response_obj);
    return response_obj.data;

  }
  
}

const addTeigiFunction = new FunctionFields();

export { addTeigiFunction };